import React, { useEffect, useState, useRef } from "react";
import { Box, Button, Text } from "grommet";
import { Attachment, Close } from "grommet-icons";
import { useTranslation } from "react-i18next";
import "./MessagePhotoInput.scss";

export default function MessagePhotoInput({ value, onChange, disabled }) {
  const { t } = useTranslation();
  const fileInputRef = useRef(null);
  const [preview, setPreview] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    if (!value) { setPreview(null); return; }
    const url = URL.createObjectURL(value);
    setPreview(url);
    return () => URL.revokeObjectURL(url);
  }, [value]);
  return <Box gap="small" className="message-photo-input">
    <Button
      type="button"
      size="small"
      hoverIndicator="accent-4"
      primary
      color="status-warning"
      icon={<Attachment size="small" />}
      aria-label={t("messagePhoto.attach")}
      title={t("messagePhoto.attach")}
      disabled={disabled}
      onClick={() => fileInputRef.current?.click()}
      className="chat-attachment-button"
    />
      <input ref={fileInputRef} type="file" accept="image/jpeg,image/png,image/webp" disabled={disabled} aria-label={t("messagePhoto.attach")}
        style={{ display: "none" }} onChange={event => {
          const file = event.target.files?.[0];
          event.target.value = "";
          if (!file) return;
          if (!["image/jpeg", "image/png", "image/webp"].includes(file.type) || file.size > 5 * 1024 * 1024) {
            setError(t("messagePhoto.invalid")); return;
          }
          setError(""); onChange(file);
        }} />
    {preview && <div className="message-photo-preview">
      <img src={preview} alt={t("messagePhoto.preview")} />
      <Button type="button" className="message-photo-remove" icon={<Close size="small" />} aria-label={t("messagePhoto.remove")} title={t("messagePhoto.remove")} disabled={disabled} onClick={() => onChange(null)} />
    </div>}
    {error && <Text className="message-photo-error" role="alert" color="status-error">{error}</Text>}
  </Box>;
}
